var _circle, _line, _line2, _line3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFloorDrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 12,
    x2: 17,
    y2: 12,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 9,
    x2: 15,
    y2: 9,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 15,
    x2: 15,
    y2: 15,
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloorDrain);
export default __webpack_public_path__ + "static/media/FloorDrain.ddc0c4600406298e25b5c07f5e4a0f79.svg";
export { ForwardRef as ReactComponent };